export default __webpack_public_path__ + "static/media/Img0015.3101df9c.png";